import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navigation from './components/Navigation';
import Dashboard from './components/Dashboard';
import Bookings from './components/Bookings';
import Services from './components/Services';
import CRM from './components/CRM';
import Marketing from './components/Marketing';
import TrustReviews from './components/TrustReviews';
import Messages from './components/Messages';
import Insights from './components/Insights';
import Settings from './components/Settings';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-sand-50 via-white to-slate-50">
        <div className="flex">
          <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
          
          <main className="flex-1 ml-64">
            <motion.div 
              className="p-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/bookings" element={<Bookings />} />
                <Route path="/services" element={<Services />} />
                <Route path="/crm" element={<CRM />} />
                <Route path="/marketing" element={<Marketing />} />
                <Route path="/trust-reviews" element={<TrustReviews />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </motion.div>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;